export default __webpack_public_path__ + "static/web_fabio_profile-47f42a239a38354d25d0d5c0923ab6e6.jpg";